import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NavigationControls = ({ 
  currentQuestion, 
  totalQuestions, 
  canGoNext, 
  canGoPrevious, 
  onPrevious, 
  onNext, 
  onSkip, 
  onSubmit,
  isLastQuestion,
  hasUnsavedChanges 
}) => {
  const [showSkipConfirm, setShowSkipConfirm] = useState(false);
  const [showSubmitConfirm, setShowSubmitConfirm] = useState(false);

  const handleSkip = () => {
    if (showSkipConfirm) {
      onSkip();
      setShowSkipConfirm(false);
    } else {
      setShowSkipConfirm(true);
    }
  };

  const handleSubmit = () => {
    if (showSubmitConfirm) {
      onSubmit();
      setShowSubmitConfirm(false);
    } else {
      setShowSubmitConfirm(true);
    }
  };

  return (
    <div className="bg-card border-t border-border p-4 md:p-6">
      {/* Skip Confirmation */}
      {showSkipConfirm && (
        <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 mb-4">
          <div className="flex items-start space-x-3">
            <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm font-medium text-warning-foreground mb-2">
                Tem certeza que deseja pular esta questão?
              </p>
              <p className="text-xs text-warning-foreground/80">
                Você poderá voltar para respondê-la mais tarde.
              </p>
              <div className="flex space-x-2 mt-3">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setShowSkipConfirm(false)}
                >
                  Cancelar
                </Button>
                <Button
                  variant="warning"
                  size="sm"
                  onClick={handleSkip}
                  iconName="SkipForward"
                  iconPosition="left"
                  iconSize={16}
                >
                  Sim, Pular
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Submit Confirmation */}
      {showSubmitConfirm && (
        <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-4">
          <div className="flex items-start space-x-3">
            <Icon name="Send" size={20} className="text-primary flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm font-medium text-primary-foreground mb-2">
                Finalizar atividade?
              </p>
              <p className="text-xs text-primary-foreground/80">
                Suas respostas serão enviadas e você não poderá mais alterá-las.
              </p>
              <div className="flex space-x-2 mt-3">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setShowSubmitConfirm(false)}
                >
                  Revisar
                </Button>
                <Button
                  variant="default"
                  size="sm"
                  onClick={handleSubmit}
                  iconName="Check"
                  iconPosition="left"
                  iconSize={16}
                >
                  Finalizar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Unsaved Changes Warning */}
      {hasUnsavedChanges && (
        <div className="bg-accent/10 border border-accent/20 rounded-lg p-3 mb-4">
          <div className="flex items-center space-x-2">
            <Icon name="Save" size={16} className="text-accent" />
            <span className="text-sm text-accent-foreground font-caption">
              Salvando alterações automaticamente...
            </span>
          </div>
        </div>
      )}

      {/* Navigation Buttons */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Button
            variant="outline"
            onClick={onPrevious}
            disabled={!canGoPrevious}
            iconName="ChevronLeft"
            iconPosition="left"
            iconSize={18}
          >
            Anterior
          </Button>
          
          <Button
            variant="ghost"
            onClick={handleSkip}
            className="text-muted-foreground hover:text-foreground"
            iconName="SkipForward"
            iconPosition="left"
            iconSize={16}
          >
            Pular
          </Button>
        </div>

        <div className="flex items-center space-x-3">
          {/* Question Counter */}
          <div className="hidden md:flex items-center space-x-2 px-3 py-2 bg-muted rounded-lg">
            <Icon name="List" size={16} className="text-muted-foreground" />
            <span className="text-sm font-caption text-muted-foreground">
              {currentQuestion} de {totalQuestions}
            </span>
          </div>

          {isLastQuestion ? (
            <Button
              variant="default"
              onClick={handleSubmit}
              disabled={!canGoNext}
              iconName="Send"
              iconPosition="right"
              iconSize={18}
              className="bg-success hover:bg-success/90"
            >
              Finalizar
            </Button>
          ) : (
            <Button
              variant="default"
              onClick={onNext}
              disabled={!canGoNext}
              iconName="ChevronRight"
              iconPosition="right"
              iconSize={18}
            >
              Próxima
            </Button>
          )}
        </div>
      </div>

      {/* Mobile Question Counter */}
      <div className="md:hidden flex items-center justify-center mt-4 pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          <Icon name="List" size={16} className="text-muted-foreground" />
          <span className="text-sm font-caption text-muted-foreground">
            Questão {currentQuestion} de {totalQuestions}
          </span>
        </div>
      </div>
    </div>
  );
};

export default NavigationControls;